///supplierproduct/list
export const SUPPLIER_PRODUCT_LIST = "SUPPLIER_PRODUCT_LIST";
export const SUPPLIER_PRODUCT_LIST_SUCCESS = "SUPPLIER_PRODUCT_LIST_SUCCESS";
export const SUPPLIER_PRODUCT_LIST_FAILURE = "SUPPLIER_PRODUCT_LIST_FAILURE";
///supplierproduct/data
export const SUPPLIER_PRODUCT_DATA = "SUPPLIER_PRODUCT_DATA";
export const SUPPLIER_PRODUCT_DATA_SUCCESS = "SUPPLIER_PRODUCT_DATA_SUCCESS";
export const SUPPLIER_PRODUCT_DATA_FAILURE = "SUPPLIER_PRODUCT_DATA_FAILURE";
///supplierproduct/search
export const SUPPLIER_PRODUCT_SEARCH = "SUPPLIER_PRODUCT_SEARCH";
export const SUPPLIER_PRODUCT_SEARCH_SUCCESS =
  "SUPPLIER_PRODUCT_SEARCH_SUCCESS";
export const SUPPLIER_PRODUCT_SEARCH_FAILURE =
  "SUPPLIER_PRODUCT_SEARCH_FAILURE";
///supplierproduct/create
export const SUPPLIER_PRODUCT_CREATE = "SUPPLIER_PRODUCT_CREATE";
export const SUPPLIER_PRODUCT_CREATE_SUCCESS =
  "SUPPLIER_PRODUCT_CREATE_SUCCESS";
export const SUPPLIER_PRODUCT_CREATE_FAILURE =
  "SUPPLIER_PRODUCT_CREATE_FAILURE";
///supplierproduct/update
export const SUPPLIER_PRODUCT_UPDATE = "SUPPLIER_PRODUCT_UPDATE";
export const SUPPLIER_PRODUCT_UPDATE_SUCCESS =
  "SUPPLIER_PRODUCT_UPDATE_SUCCESS";
export const SUPPLIER_PRODUCT_UPDATE_FAILURE =
  "SUPPLIER_PRODUCT_UPDATE_FAILURE";
///supplierproduct/delete
export const SUPPLIER_PRODUCT_DELETE = "SUPPLIER_PRODUCT_DELETE";
export const SUPPLIER_PRODUCT_DELETE_SUCCESS =
  "SUPPLIER_PRODUCT_DELETE_SUCCESS";
export const SUPPLIER_PRODUCT_DELETE_FAILURE =
  "SUPPLIER_PRODUCT_DELETE_FAILURE";
